'use client'

import { PrismicRichText } from "@prismicio/react";
import { useRef } from "react";

const SideMenuMobile = ({ page }) => {

  const $block = useRef();

  function toggleRef() {
    $block.current.classList.toggle('max-h-[1000px]');
  }

  function goToSection(e) {
    const text = e.target.dataset.pointer
    const d = document.getElementById(text);
    window.scrollTo({
      behavior: 'smooth',
      top:
        d.getBoundingClientRect().top -
        document.body.getBoundingClientRect().top -
        110,
    })
  }

  return <div className="w-full lg:hidden">
    <div className="bg-pink border-y-2 border-dark-grey text-summary">
      <div className="px-30px py-2 border-dark-grey flex items-center justify-between toggle-btn" onClick={toggleRef}>
        <p className="flex-1">Sommaire</p>
        <div className="w-fit">
          <div className="spin_arrow">
            <img src='/svg/arrow-faq.svg' className="w-full h-auto" loading="lazy"/>
          </div>
        </div>
      </div>
      <div ref={$block} className="mx-30px sumup-wrapper max-h-0 overflow-hidden transition-all duration-300">
        {
          page.data.slices.filter(slice => slice.slice_type == 'article_rich_text').map((elem, i) => <PrismicRichText
            key={i}
            field={elem.primary.text.filter(elem => elem.type === 'heading2')}
            components={{
              heading2: ({ children, text }) => <div className="py-5 last:pb-10" onClick={goToSection}>
                <h4 data-pointer={`${text.split(" ").join("-").split("'").join("-").split(':').join('').split('(').join('').split(')').join('').split('--').join('-')}`} className=" cursor-pointer article-sumup-title transition-opacity">{children}</h4>
              </div>,
            }}
          />) //serializerSumUp
        }
      </div>
    </div>
  </div>

}

export default SideMenuMobile